import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ViewModeEnum, AlertDialogTypeEnum } from '../../../_enums/_index';
import { ServiceItemModel, ServiceTypeModel } from '../../../_models/_index';
import { ServiceItemService } from '../../../services/service-item.service';
import { InfraService } from '../../../services/_index';
@Component({
  selector: 'app-service-item-dialog',
  templateUrl: './service-item-dialog.component.html',
  styleUrls: ['./service-item-dialog.component.css']
})
export class ServiceItemDialogComponent implements OnInit {
    dialogHeader: string;
    viewMode: ViewModeEnum;
    serviceItem: ServiceItemModel = new ServiceItemModel();
    serviceTypeList: ServiceTypeModel[];

    constructor(private serviceItemService: ServiceItemService,
        private infraService: InfraService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<ServiceItemDialogComponent>) { }

    ngOnInit() {
        this.loadServiceType();
  }

  getSaveText() {
      switch (this.viewMode) {
          case ViewModeEnum.Add:
              return "הוסף";
          case ViewModeEnum.Edit:
              return "עדכן";
      }
  }

  save() {
      if (this.viewMode == ViewModeEnum.Add) {
          this.add();
      }
      else {
          this.edit();
      }
  }

  private add() {
      this.serviceItemService.addServiceItem(this.serviceItem).then((result: ServiceItemModel) => {
          if (result) {
              this.dialogRef.close(result);
          }
      });
  }

  private edit() {
      this.serviceItemService.editServiceItem(this.serviceItem).then((result: ServiceItemModel) => {
          if (result) {
              this.dialogRef.close(result);
          }
      });
  }

  private isEditMode() {
      return this.viewMode == ViewModeEnum.Edit;
  }

  private loadServiceType() {
      this.infraService.getServiceType().then(result => {
          this.serviceTypeList = result;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/service-items/service-item-dialog/service-item-dialog.component.ts